<script>
    import { currency_formatter } from '../../globals';
    import { push, querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import breakpoints from "../../utils/breakpoints";
    import { api_host, company_details_store } from '../../stores.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { formatDateAndTime, formatDate, jobStatsToNum } from '../../utils/format.js';
    import { toast_message } from '../../utils/toast_message';
    import { getTax, renderExtraContractorPriceTable, renderMainServicePriceTable, renderExtraServicePriceTable, getSubtotal, getTotalTax, isNewLayout, get_extra_service_prices } from '../../utils/tax.js';

    
    
    const { auth_type, auth_token, domain_code } = getToken();
    const bp = breakpoints();

    let content_title = "Invoice Review";
    let iid = "";
    let is_busy = false;
    let invoice = {};
    let avatar = '';

    company_details_store.subscribe(value => {
        avatar = value.avatar;
    });

    onMount(async () => {
        const params = new URLSearchParams($querystring);

        if (params.has("iid")) {
            iid = params.get("iid");
            const res = await doFetch(
                `${api_host}/api/invoice/get/${iid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                console.log('invoice', res.invoice);
                invoice = res.invoice;
            } else {
                toast_message(false, res.msg || 'Failed', 2000);
            }
        }
    });

</script>


<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="buttonholder">
        <button class="invoice_btn" on:click={async () => {
            is_busy = true;
            const res = await doFetch(
                `${api_host}/api/invoice/send/${iid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 2000);
            } else {
                toast_message(false, res.msg || 'Invoice failed', 2000);
            }
            is_busy = false;
        }}>
            <i class="far fa-clock"></i> Send Invoice
        </button>

        <button class="job_btn" on:click={async () => {
            push(`#/Job_Review?jid=${invoice.job.id}`);
        }}>
            <i class="far fa-calendar-alt"></i> View Job
        </button>

        <button on:click={async () => {
            window.open(`${api_host}/api/invoice/pdf/${invoice.slug}`, '_blank');
        }}>
            <i class="far fa-download"></i> PDF
        </button>
    </div>
    <br />
    {#if Object.keys(invoice).length}
    <div class="invoiceholder">
        <div class="headerrow">
            {#if avatar}
                <img src="{avatar}" width="100px" alt='logo' />
            {/if}
            <!-- <div class="contractorname">{contractor.name}</div>
            <div class="invoicetitle">Invoice</div> -->
        </div>
        <div class="invoiceinfo row">
            <div class="column right">
                <div class="sectionheader">Invoice Information</div>
                <div class="invoicetable">
                    <table>
                        <tr>
                            <td>Issued date</td>
                            <td>{formatDateAndTime(invoice.job.approved_at)}</td>
                        </tr>
                        <tr>
                            <td>Invoice number</td>
                            <td>{invoice.invoice.invoice_number.toUpperCase()}</td>
                        </tr>
                    </table>
                </div>
                <!-- <div class="infoitem">
                    <div class="infoitemtitle">Issued date:</div>
                    <div class="infoitemvalue">{formatDateAndTime(invoice.job.approved_at)}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Invoice number:</div>
                    <div class="infoitemvalue">{invoice.invoice.invoice_number.toUpperCase()}</div>
                </div> -->
            </div>
            <div class="column left">
                <div class="sectionheader">Bill to</div>
                <div class="invoicetable">
                    <table>
                        <tr>
                            <td>Client name</td>
                            <td>{`${invoice.user.first_name} ${invoice.user.last_name}`}</td>
                        </tr>
                    </table>
                </div>
                <!-- <div class="infoitem">
                    <div class="infoitemtitle">Client name:</div>
                    <div class="infoitemvalue">{`${invoice.user.first_name} ${invoice.user.last_name}`}</div>
                </div> -->
            </div>
            <div class="column left">
                <div class="sectionheader">Description</div>
                <div class="invoicetable">
                    <table>
                        <tr>
                            <td>Service address</td>
                            <td>{`${invoice.job.address}, ${invoice.job.city}, ${invoice.job.state}`}</td>
                        </tr>
                        <tr>
                            <td>Service date</td>
                            <td>{`${formatDate(invoice.job.service_date)}`}</td>
                        </tr>
                        <tr>
                            <td>Service type</td>
                            <td>{`${invoice.job.service_type}`}</td>
                        </tr>
                        <tr>
                            <td>Service frequency</td>
                            <td>{`${invoice.job.service_frequency}`}</td>
                        </tr>
                        {#if invoice.job.additional_comments}
                        <tr>
                            <td>Service description</td>
                            <td>{`${invoice.job.additional_comments}`}</td>
                        </tr>
                        {/if}
                        {#if isNewLayout(invoice.job)}
                        <tr>
                            <td>Service price</td>
                            <td>{@html renderMainServicePriceTable(invoice.job.service_prices)}</td>
                        </tr>
                        <tr>
                            <td>Extra Service Price</td>
                            <td>{@html renderExtraServicePriceTable(invoice.job.service_prices)}</td>
                        </tr>
                        <tr>
                            <td>Subtotal</td>
                            <td>${getSubtotal(invoice.job.service_prices)}</td>
                        </tr>
                        <tr>
                            <td>Tax</td>
                            <td>${getTotalTax(invoice.job.service_prices)}</td>
                        </tr>
                        {:else}
                        <tr>
                            <td>Service Price</td>
                            <td>${invoice.job.service_price}</td>
                        </tr>
                        <tr>
                            <td>Extra Service Price:</td>
                            <td>${invoice.job.extra_service_price}</td>
                        </tr>
                        {/if}
                        <tr>
                            <td>Total Service Price (service price added to extra price)</td>
                            <td>{currency_formatter.format(invoice.job.total_service_price)}</td>
                        </tr>
                        <tr>
                            <td>Payment</td>
                            <td>{currency_formatter.format(invoice.invoice.paid_amount)}</td>
                        </tr>
                        <tr>
                            <td>Balance due</td>
                            <td>{currency_formatter.format(invoice.invoice.due_balance)}</td>
                        </tr>
                    </table>
                </div>
                <!-- <div class="infoitem">
                    <div class="infoitemtitle">Service address:</div>
                    <div class="infoitemvalue">{`${invoice.job.address}, ${invoice.job.city}, ${invoice.job.state}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Service date:</div>
                    <div class="infoitemvalue">{`${formatDate(invoice.job.service_date)}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Service type:</div>
                    <div class="infoitemvalue">{`${invoice.job.service_type}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Service frequency:</div>
                    <div class="infoitemvalue">{`${invoice.job.service_frequency}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Service price:</div>
                    <div class="infoitemvalue">{`$${invoice.job.service_price}`}</div>
                </div>
                {#if invoice.job.additional_comments}
                <div class="infoitem">
                    <div class="infoitemtitle">Service description:</div>
                    <div class="infoitemvalue">{`${invoice.job.additional_comments}`}</div>
                </div>
                {/if}
                <div class="infoitem">
                    <div class="infoitemtitle">Extra price:</div>
                    <div class="infoitemvalue">{`$${invoice.job.extra_service_price}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Subtotal price (service price adds to extra price):</div>
                    <div class="infoitemvalue">{`$${invoice.job.total_service_price}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Payment:</div>
                    <div class="infoitemvalue">{`$${invoice.job.total_service_price}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Balance due:</div>
                    <div class="infoitemvalue">{`$${invoice.job.total_service_price}`}</div>
                </div> -->
            </div>
        </div>
    </div>
    {/if}
</div>


<style>
    .buttonholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        grid-area: bh;
    }
    .buttonholder button {
        padding-left: 15px;
        padding-right: 15px;
        margin-right: 10px;
        margin-top: 10px;
    }
    .buttonholder button.invoice_btn{
        background-color: #ff9100;
        color: white;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button {
            width: 100%;
            /* text-align: left; */
        }
    }
    .headerrow {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .column {
        /* padding: 10px; */
        margin: 0px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .row {
        /* padding: 5px; */
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        box-sizing: border-box;
    }
    .sectionheader{
        width: 100%;
        margin-top: 10px;
        /* margin-bottom: 10px; */
        /* font-weight: bold; */
        font-size: 16px;
        background-color: #999;
        color: white;
        padding: 5px;
        box-sizing: border-box;
    }
    .invoicetable {
        width: 100%;
    }
    .invoicetable table {
        border-collapse: collapse;
        width: 100%;        
    }
    .invoicetable table tr:nth-child(even){
        background-color: #f2f2f2;
    }
    .invoicetable table tr:hover{
        background-color: #ddd;
    }
    .invoicetable table tr td:first-child {
        width: 400px;
    }
    .invoicetable table td {
        border: 1px solid #ddd;    
        padding: 8px;
    }
    @media (max-device-width: 600px), (max-width: 599px) {
        .invoicetable table tr td:first-child {
            width: 50%;
        }
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .invoiceholder {
            width: 95%;
            margin-left: auto;
            margin-right: auto;
        }
        .headerrow {
            display: flex;
            flex-direction: column-reverse;
        }
        .column{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .row{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
    }
</style>